import React from 'react';

const Logo = ({ className = "h-12", darkMode, small }) => (
    <div className="flex items-end">
        <div>
            <img src="/images/logo_home_click_highres.png" alt="Logo" className={className} />
        </div>
        <div className="flex items-baseline ml-2">
            <span className={`${small ? 'text-lg' : 'text-2xl'} font-bold font-montserrat ${darkMode ? 'text-white' : 'text-brand-dark'}`}>
                Håndværker
            </span>
            <span className={`${small ? 'text-lg' : 'text-2xl'} font-bold font-montserrat text-brand-light`}>
                Net
            </span>
        </div>
    </div>
);

export default Logo;